import Vue from 'vue';
import kidSchoolApi from '@/api/kidSchoolApi';
const STORAGE_KEY = 'kidSchoolQueue';
const FLUSH_INTERVAL = 15000;
const state = Vue.observable({ pending: 0 });
const drainListeners = [];
let flushing = false;
function read() {
    try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    }
    catch (e) {
        console.error(e);
        return [];
    }
}
function write(queue) {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(queue));
    }
    catch (e) {
        console.error(e);
    }
    state.pending = queue.length;
}
/**
 * A write worth repeating: the request never reached the backoffice, or it
 * answered that it was busy. A refusal (4xx) would be refused again.
 */
export function shouldQueue(error) {
    const status = error?.response?.status;
    if (status === undefined) {
        return true;
    }
    return status === 408 || status === 429 || status >= 500;
}
/** Keeps the write until the backoffice takes it; every queued write is idempotent. */
export function enqueue(request) {
    write([...read(), request]);
    setTimeout(flush, FLUSH_INTERVAL);
}
/** Runs when the queue empties, so a screen can read back what was written. */
export function onDrained(listener) {
    drainListeners.push(listener);
}
export async function flush() {
    if (flushing) {
        return;
    }
    flushing = true;
    try {
        let queue = read();
        while (queue.length > 0) {
            const request = queue[0];
            try {
                await kidSchoolApi.request({ method: request.method, url: request.url, data: request.body });
            }
            catch (e) {
                if (shouldQueue(e)) {
                    return;
                }
                // The backoffice refused it; repeating it would change nothing.
                console.error(e);
            }
            queue = read().slice(1);
            write(queue);
        }
        drainListeners.forEach(listener => listener());
    }
    finally {
        flushing = false;
    }
}
export function pendingCount() {
    return state.pending;
}
state.pending = read().length;
window.addEventListener('online', () => void flush());
setInterval(() => void flush(), FLUSH_INTERVAL);
